import { render, staticRenderFns } from "./M5Index.vue?vue&type=template&id=dfc511d0&"
import script from "./M5Index.vue?vue&type=script&lang=js&"
export * from "./M5Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports